<script>
    import Spinner from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Spinner.svelte?1733898724588';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724588';
    import { direct_purchase } from '/srv/web/wyvr/html/releases/58819/gen/client/checkout_buttons/direct_purchase.js?1733898724588';

    wyvr: {
        render: 'hydrate';
        loading: 'interact';
    }

    export let product = null;

    let state = 'idle';

    $: sku = get_attribute_value(product, 'sku');

    async function purchase(e) {
        state = 'busy';
        await direct_purchase(product, 'cart');
        state = 'idle';
    }

    const title = window.__('checkout_buttons.amazon_pay');
</script>

<div class="product-amazon-pay-button">
    {#if state == 'busy'}
        <Spinner />
    {:else}
        <button on:click={purchase} class="btn" data-ax-uid={sku} data-ax-event="directCheckoutAdd" aria-label={title}>
            <span class="icon-amazon" {title} />
            {title}
        </button>
    {/if}
</div>
